<template>
  <div class="operation-report-show-body-form-group flex flex-col">
    <operation-report-show-body-form
      v-for="formRecord in formRecords"
      :key="formRecord.operationWorkflowForm.id"
      v-bind="formRecord"
      :reportId="reportId"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("operationReport");
import OperationReportShowBodyForm from "./Form";
import { isEditingReport } from "@/utils/operations";

export default {
  name: "OperationReportShowBodyFormGroup",

  components: { OperationReportShowBodyForm },

  computed: {
    ...mapGetters({
      reportId: "reportId",
      reportOperationWorkflowForms: "reportOperationWorkflowForms",
      reportEnterpriseFormMap: "reportEnterpriseFormMap",
      reportFormVersionMapByFormVersionId:
        "reportFormVersionMapByFormVersionId",
      reportFormUpdatableMapByOperationWorkflowFormId:
        "reportFormUpdatableMapByOperationWorkflowFormId",
    }),
    formRecords() {
      return this.reportOperationWorkflowForms.map(operationWorkflowForm => {
        const enterpriseForm = this.reportEnterpriseFormMap[
          operationWorkflowForm.form_id
        ];
        const enterpriseFormVersion = enterpriseForm.form_versions.find(
          formVersion =>
            this.reportFormVersionMapByFormVersionId[formVersion.id]
        );
        const reportFormVersion = this.reportFormVersionMapByFormVersionId[
          enterpriseFormVersion.id
        ];
        const updatable = this
          .reportFormUpdatableMapByOperationWorkflowFormId[
          operationWorkflowForm.id
        ];
        const isEditing = this.isEditingReport;
        return {
          operationWorkflowForm,
          enterpriseForm,
          enterpriseFormVersion,
          reportFormVersion,
          updatable, // 更新権限があるか
          isEditing, // 編集中かどうか
          // SET_FORM_VERSION_ITEM_VALUE は ao_enterprise_vessel_report_form_versions の id で
          // 書き込み先を特定するため、ここでは reportFormVersion.id を渡す。
          reportFormVersionId: reportFormVersion && reportFormVersion.id,
        };
      });
    },
    isEditingReport() {
      return isEditingReport(this);
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-form-group {
  padding-top: 30px;
  row-gap: 50px;
}
</style>
